const mapping = {
    'fa-file-text-o': ['text/plain'],
    'fa-file-image-o': ['image/.*'],
    'fa-file-video-o': ['video/.*'],
    'fa-file-audio-o': ['audio/.*'],
    'fa-file-pdf-o': ['application/pdf'],
    'fa-file-archive-o': [
        'application/zip',
        'application/x-rar-compressed',
    ],
    'fa-file-word-o': [
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
    'fa-file-excel-o': [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/csv',
    ],
    'fa-file-powerpoint-o': [
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ],
};

const defaultIcon = 'fa-file-o';

export function mimeTypeIconClass(mimeType) {
    for (let faClass in mapping) {
        for (let pattern of mapping[faClass]) {
            if (mimeType.match('^'+pattern+'$'))
                return faClass;
        }
    }

    return defaultIcon;
}
